import { Spinner, SpinnerStyle } from "@redotech/redo-web/spinner";
import { ReactNode, memo } from "react";
import * as common from "./common.module.css";

export const Title = memo(({ children }: { children?: ReactNode }) => (
  <h1 className={common.title}>{children}</h1>
));

export const LoadingRedoAnimation = memo(() => {
  return (
    <div className={common.loadingSpinner}>
      <div className={common.spinnerContainer}>
        <Spinner style={SpinnerStyle.DARK} />
      </div>
    </div>
  );
});
